const modTwoData = {
  module: 2,
  category: 'Frontend Fundamentals',
  days: [
    {
      link: "https://replit.com/@HannahHudson/M2AdventDay1#index.js",
      emoji: "🍪"
    },
    {
      link: "https://github.com/turingschool-examples/receipt-comp",
      emoji: "🧾"
    },
    {
      link: "https://github.com/turingschool-examples/get-some-gifts",
      emoji: "🎁"
    },
    {
      link: "https://github.com/turingschool-examples/treehouse-driven-development",
      emoji: "🏡"
    },
    {
      link: "https://replit.com/@HannahHudson/winter-activities",
      emoji: "⛷️"
    },
    {
      link: "https://github.com/turingschool-examples/post-a-gift",
      emoji: "✉️"
    },
    {
      link: "https://gist.github.com/hannahhch/6d86e3733556848cb730d657ff72810a",
      emoji: "😌"
    },
    {
      link: "https://github.com/turingschool-examples/kitchen-clean-up",
      emoji: "👩‍🍳"
    },
    {
      link: "https://replit.com/@HannahHudson/spicy-soup",
      emoji: "🍲"
    },
    {
      link: "https://github.com/turingschool-examples/packing-list",
      emoji: "🧳"
    }
  ]
};

export default modTwoData;
